import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/feedSettings.svg';

export const IconFeedSettings = createIconComponent(Icon);
